import React, { useEffect, useState } from 'react';
import { useLanguageCode } from './TranslationContext';
import { useGlue } from '../hooks';
const AxiosTranslationComponent = ({ children }) => {
    const [languageCode] = useLanguageCode();
    const glue = useGlue();
    const [ready, setReady] = useState(false);
    useEffect(() => {
        const languageInterceptor = glue.api.interceptors.request.use((config) => {
            if (glue.isFrontTranslationEnabled()) {
                config.params = Object.assign(Object.assign({}, config.params), { lang: languageCode });
            }
            return config;
        });
        setReady(true);
        return () => {
            glue.api.interceptors.request.eject(languageInterceptor);
            setReady(false);
        };
    }, [glue.api, glue.isFrontTranslationEnabled, languageCode, setReady]);
    if (ready)
        return React.createElement(React.Fragment, null, children);
    else
        return null;
};
export const AxiosTranslationProvider = ({ children }) => {
    const [languageCode] = useLanguageCode();
    if (languageCode)
        return React.createElement(AxiosTranslationComponent, { key: languageCode }, children);
    else
        return null;
};
//# sourceMappingURL=AxiosTranslationProvider.js.map